import { render, staticRenderFns } from "./majorlist.vue?vue&type=template&id=4fffb970&scoped=true"
import script from "./majorlist.vue?vue&type=script&lang=js"
export * from "./majorlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fffb970",
  null
  
)

export default component.exports